// Plain API helpers for survey results + image upload.
// These are thin fetch wrappers with no shared client state, so they don't need a
// state library (Redux holds the survey condition; these just talk to the backend).

// Defaults to "" so the CRA dev proxy handles same-origin /api requests locally.
// Override with REACT_APP_API_BASE for non-proxied deployments.
const API_BASE = process.env.REACT_APP_API_BASE || ""

export async function createResults(newResults) {
    try {
        const res = await fetch(API_BASE + "/api/survey", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newResults),
        })
        if (!res.ok) {
            return { success: false, message: "Server responded with status " + res.status }
        }
        return { success: true, message: "Results created!" }
    } catch (error) {
        console.log("Error in creating results: ", error.message)
        return { success: false, message: "Create results failed with error: " + error.message }
    }
}

export async function uploadImage(image, imageName) {
    try {
        // `image` is a data URL from canvas.toDataURL("image/png"). POST the raw PNG
        // bytes (Content-Type image/png) instead of a base64 string wrapped in JSON.
        // This drops the ~33% base64 inflation and, more importantly, the server-side
        // synchronous JSON.parse of a multi-MB body. The browser decodes the data URL
        // to a binary Blob natively via fetch().
        const blob = await (await fetch(image)).blob()
        const res = await fetch(API_BASE + "/api/survey/uploadImage?imageName=" + encodeURIComponent(imageName), {
            method: "POST",
            headers: { "Content-Type": "image/png" },
            body: blob,
        })
        if (!res.ok) {
            return { success: false, message: "Server responded with status " + res.status }
        }
        return { success: true, message: "Image uploaded!" }
    } catch (error) {
        console.log("Error in saving image: ", error.message)
        return { success: false, message: "Upload failed with error: " + error.message }
    }
}
